import React, { useContext, useEffect, useState } from "react";
import "./HistoricLogo.css";
import blogFetch from "../../axios/config";
import Context from "../../context/Context";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import {
  Button,
  Col,
  Container,
  Modal,
  Row,
  InputGroup,
  Form,
} from "react-bootstrap";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { DateTimeFmt } from "../../utils/DataUtils";
import Loading from "../../components/Loading";

export const HistoricLogo = () => {
  const { loading, setLoading } = useContext(Context);

  const [logoHistory, setLogoHistory] = useState([]);
  const [imageSrc, setImageSrc] = useState(null);
  const [showImage, setShowImage] = useState(false);
  const [dtInicio, setDtInicio] = useState(dayjs().subtract(1, "day"));
  const [dtFim, setDtFim] = useState(dayjs());
  const [searchHistory, setSearchHistory] = useState("");
  const [status, setStatus] = useState("STATUS");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredLogoHistory, setFilteredLogoHistory] = useState([]);

  const urlKey = "?sv=2024-11-04&ss=bfqt&srt=sco&sp=rwlacuptfx&se=2050-06-12T20:16:31Z&st=2025-06-12T12:16:31Z&sip=0.0.0.0-255.255.255.255&spr=https,http&sig=tl%2BcpEPI682MiVTAt%2FLwiNfvuwz04cuAcAjT5NwD9fM%3D"


  useEffect(() => {
    getLogoHistory();
  }, []);

  useEffect(() => {
    if (dtInicio && dtFim && status) getLogoHistory(dtInicio, dtFim, status);
  }, [dtFim, dtInicio, status]);

  const getLogoHistory = async () => {
    setLoading(true);
    try {
      const { data } = await blogFetch.get(
        `/SAGA_ConferenciaLogo/historico?startDate=${dtInicio.toISOString()}`
      );
      setLogoHistory(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleShowImage = (image) => {
    setImageSrc(image);
    setShowImage(true);
  };

  const handleCloseImage = () => {
    setShowImage(false);
  };

  console.log(logoHistory);


  const handleSearch = async (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    const isLote = /^\d+$/.test(value);

    if (isLote) {
      try {
        const response = await blogFetch.get(`/SAGA_ConferenciaLogo/search/history/${value}`);
        setFilteredLogoHistory(response.data);
      } catch (err) {
        console.error("Erro ao buscar lote:", err);
        setFilteredLogoHistory([]);
      }
    } else {
      const filtered = logoHistory.filter((item) =>
        item.conf_Client?.toLowerCase().includes(value.toLowerCase()) ||
        item.conf_Lote?.toString().toLowerCase().includes(value.toLowerCase()) ||
        item._Creat?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredLogoHistory(filtered);
    }
  };

  const handleUpdateStatus = async (id) => {
    let user = JSON.parse(localStorage.getItem("user"));

    try {
      await blogFetch.put(
        `/SAGA_ConferenciaLogo/updateStatus/${id}`,
        JSON.stringify(user.user_UserName),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Atualiza localmente o estado para refletir já confirmado
      setLogoHistory((prev) =>
        prev.map((item) =>
          item.conf_Key === id
            ? {
              ...item,
              Conf_Verificado: true,
              Conf_ResVerificado: user.user_UserName,
              Conf_DtVerificado: new Date().toISOString(),
            }
            : item
        )
      );
    } catch (error) {
      console.error("Erro ao confirmar logo:", error);
    }
  };

  useEffect(() => {
    setFilteredLogoHistory(logoHistory);
  }, [logoHistory]);




  return (
    <>
      <Navbar />
      <Sidebar />
      <div className="app_body historico">
        <div className="filtros_historico">
          <div className="data_picker_wrapper">
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                value={dtInicio}
                onChange={(newValue) => setDtInicio(newValue ?? dayjs())}
              />
            </LocalizationProvider>
          </div>

          <div className="search_wrapper">
            <input
              className="search_input_historico"
              placeholder="Buscar por Lote, Cliente ou Responsável"
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
        </div>

        <Container fluid>
          <Row>
            <Col>
              {!loading ? (
                <div className="wrapper_historico">
                  <table className="table_historico">
                    <thead className="thead_historico">
                      <tr>
                        <th className="th_historico">LOTE</th>
                        <th className="th_historico">LOGO</th>
                        <th className="th_historico">CLIENTE</th>
                        <th className="th_historico">PEÇA</th>
                        <th className="th_historico">SEPARADO</th>
                        <th className="th_historico">DATA DA CRIAÇAO</th>
                        <th className="th_historico">LOGO SOLICITADA</th>
                        <th className="th_historico">FOTO RETIRADA</th>
                        <th className="th_historico">AÇÃO</th>
                        <th className="th_historico">CONFERIDO</th>
                        <th className="th_historico">DATA DA VERIFICAÇÃO</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredLogoHistory.map((item, index) => (
                        <tr key={index} className="tr_even_historico">
                          <td className="td_historico">{item.conf_Lote}</td>
                          <td className="td_historico">{item.conf_Logo}</td>
                          <td className="td_historico">{item.conf_Client}</td>
                          <td className="td_historico">{item.tipo_Peca}</td>
                          <td className="td_historico">{item._Creat}</td>
                          <td className="td_historico">
                            {DateTimeFmt(item._ts_Creat)}
                          </td>
                          <td className="td_historico">

                            <div className={`${item.pedido_Produto?.toLowerCase().includes("ib") ||
                                  item.pedido_Produto?.toLowerCase().includes("i-b")
                                  ? "image_alert"
                                  : ""
                                }`}>
                              <img
                              src={item.logoUrl}
                              className="image_historico"
                              alt="logo"
                              onClick={() => handleShowImage(item.logoUrl)}
                              
                            />
                            {item.pedido_Produto?.toLowerCase().includes("ib") ||
                              item.pedido_Produto?.toLowerCase().includes("i-b") ? (
                              <h3 className=''>ATENÇÃO</h3>
                            ) : null}
                            </div>
                            

                            
                          </td>
                          <td className="td_historico">
                            <img
                              src={item.conf_Image + urlKey}
                              alt="image"
                              onClick={() => handleShowImage(item.conf_Image + urlKey)}
                              className="image_historico"
                            />
                          </td>
                          <td className="td_historico">
                            <button
                              className="button_historico"
                              onClick={() => handleUpdateStatus(item.conf_Key)}
                              disabled={
                                item.conf_Verificado || item.Conf_Verificado
                              }
                            >
                              {item.conf_Verificado || item.Conf_Verificado
                                ? "Confirmado"
                                : "Confirmar"}
                            </button>
                          </td>
                          <td className="td_historico">
                            {item.conf_ResVerificado}
                          </td>
                          <td className="td_historico">
                            {DateTimeFmt(item.conf_DtVerificado)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (<Loading />)}
            </Col>
          </Row>

          <Modal
            size="lg"
            show={showImage}
            onHide={handleCloseImage}
            centered
            dialogClassName="custom-modal"
          >
            <Modal.Header
              closeButton
              className="border-b border-gray-300 bg-gray-100 rounded-t-lg"
            >
              <Modal.Title className="text-lg font-semibold text-gray-700">
                Imagem do Vagão
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-white rounded-b-lg">
              <img
                className="max-w-full max-h-[400px] items-center justify-center rounded shadow-md transition-all duration-300"
                src={imageSrc}
                alt="Vagao Image"
              />
            </Modal.Body>
          </Modal>
        </Container>
      </div>
    </>
  );
};
